/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field__Enum_Schoolname_Robert_Koch_Schule_Frankfurt5Inputs */

const en__field__enum_schoolname_robert_koch_schule_frankfurt5 = /** @type {(inputs: _Field__Enum_Schoolname_Robert_Koch_Schule_Frankfurt5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frankfurt`)
};

const de__field__enum_schoolname_robert_koch_schule_frankfurt5 = /** @type {(inputs: _Field__Enum_Schoolname_Robert_Koch_Schule_Frankfurt5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Robert-Koch-Schule`)
};

/**
* | output |
* | --- |
* | "Frankfurt" |
*
* @param {_Field__Enum_Schoolname_Robert_Koch_Schule_Frankfurt5Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field__enum_schoolname_robert_koch_schule_frankfurt5 = /** @type {((inputs?: _Field__Enum_Schoolname_Robert_Koch_Schule_Frankfurt5Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field__Enum_Schoolname_Robert_Koch_Schule_Frankfurt5Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field__enum_schoolname_robert_koch_schule_frankfurt5(inputs)
	return de__field__enum_schoolname_robert_koch_schule_frankfurt5(inputs)
});
export { _field__enum_schoolname_robert_koch_schule_frankfurt5 as "_field__enum_schoolName_Robert_Koch_Schule_Frankfurt" }